import HandsonTable from "../../../../components/handsonTable/handsonTable";
import { connect } from "react-redux";

export default connect((state) => ({
  showExportFileButton: true,
  data: state.multiLocationOverview.overviewTableData.tableInfo.data,
  colHeaders: state.multiLocationOverview.overviewTableData.tableInfo.colHeaders,
  columns: state.multiLocationOverview.overviewTableData.tableInfo.columns,
  width: 1330,
  height:
    state.multiLocationOverview.overviewTableData.tableInfo.data.length === 1 || state.multiLocationOverview.overviewTableData.tableInfo.data.length === 2
      ? state.multiLocationOverview.overviewTableData.tableInfo.data.length * 80
      : state.multiLocationOverview.overviewTableData.tableInfo.data.length * 55,
  fragmentSelection: true,
  stretchH: "all",
  columnSorting: false
}))(HandsonTable);
